import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { inboxSearchSchema, StoreInboxPage } from '@/features/conversations';

/** The same inbox with the store filter pinned to this store. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/inbox')({
  staticData: { crumb: 'common:nav.inbox' },
  validateSearch: inboxSearchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'conversations.read');
  },
  component: StoreInboxPage,
});
